// Unduh file dari string (mis. CSV) di sisi klien. Melewati guard export dulu (kontrol anti-pencurian DB).
import { passExportGuard } from './export-guard';

export async function downloadFile(content: string, filename: string, mime = 'text/csv;charset=utf-8'): Promise<boolean> {
  if (!(await passExportGuard(filename))) return false; // diblok/di-request → tak mengunduh
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
  return true;
}

/** Escape 1 sel CSV + netralkan formula-injection spreadsheet (=,+,-,@,tab,CR).
 *  Angka negatif murni (mis. -5000) dibiarkan tetap numerik agar analisis di Excel/Sheets tak rusak. */
export const csvCell = (s: unknown): string => {
  let v = String(s ?? '');
  if (/^[=+\-@\t\r]/.test(v) && !/^-?\d+(?:\.\d+)?$/.test(v)) v = "'" + v;
  return `"${v.replace(/"/g, '""')}"`;
};
